import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PrivateRoutes } from 'src/app/config/config.routes';

// Service
import { ModalUserTypeService } from '../../components/modal-user-type/modal-user-type.service';

/**
 * Guard to force the user to choose an app
 */
export const isLoginGuard: CanActivateFn = (route) => {
  const modalUserTypeService = inject(ModalUserTypeService);
  const router = inject(Router);

  if (localStorage.getItem('token')) {
    modalUserTypeService.hideModal();
    const redirectUrl =
      route.queryParamMap.get('redirectUrl') || PrivateRoutes.HOME;
    router.navigateByUrl(redirectUrl);
  }
  return true;
};
